<template>
    <div class="rb">
        <div ref="Rmain" class="Rmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as methods from "./method.js";

export default {
    name: "template.scope110",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: "00:00", value2: "5" },
                { value1: "04:00", value2: "7" },
                { value1: "08:00", value2: "3" },
                { value1: "10:00", value2: "2" },
                { value1: "12:00", value2: "6" },
                { value1: "14:00", value2: "4" },
                { value1: "16:00", value2: "5" },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "图例", key: "value3" },
                { name: "单位", key: "value4" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            iscontact: false,
            autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n.filter(
                    (item) => item && item[this.valueMap[0].key]
                );
                this.TdrawLine();
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.TdrawLine()
        }
    },
    methods: {
        ...methods,
        TdrawLine() {
            clearInterval(this.timer);
            this.timer = null;
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.Rmain);
            let myDate = this.defaultdata.map((item) => {
                return item.value1;
            });
            let numA = this.defaultdata.map((item) => {
                return +item.value2;
            });
            let unit = this.defaultdata[0].value4 || '';
            const percent = (7 / myDate.length) * 100;
            let onepercent = (1 / myDate.length) * 100;
            let zoom = [
                {
                    id: "scope110", // 唯一的idtype: 'slider',
                    moveHandleSize: 0,
                    showDetail: false, //关闭：拖拽时候显示详细数值信息。	
                    dataBackground: {
                        show: false,
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    selectedDataBackground: {
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    backgroundColor: "transparent",
                    fillerColor: "rgba(0,0,0,.2)",
                    borderColor: "transparent",
                    start: 0,
                    brushSelect: false,
                    end: percent
                },
            ];
            var Toption = {
                title: {
                    subtext: unit || "",
                    subtextStyle: {
                        color: "#B0B5BB",
                    },
                    top: "0",
                    left: "0    ",
                },
                grid: {
                    left: "5px",
                    right: "15px",
                    bottom: "0px",
                    top: "40px",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "axis",
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: myDate,
                    axisLabel: {
                        interval: 0,
                        width: 50,
                        rotate: 45,
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                            fontSize: "10",
                            lineHeight: 10,
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            // X 轴颜色配置
                            color: "#4792e9",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                },

                yAxis: {
                    type: "value",
                    splitNumber: 2,
                    axisLabel: {
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为灰白色
                        },
                        fontSize: 14,
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                },
                series: [
                    {
                        data: numA,
                        type: "line",
                        areaStyle: {},
                        smooth: true,
                        symbol: "none",
                        lineStyle: {
                            color: "#0A72FC",
                            width: 2,
                        },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: "#0b56bd", // 0% 处的颜色
                                        },
                                        {
                                            offset: 0.6,
                                            color: "#0c2a5c", // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: "rgba(0,0,0,.3)", // 100% 处的颜色
                                        },
                                    ],
                                    false
                                ),
                            },
                        },
                    },
                ],
                dataZoom: myDate.length > 7 ? zoom : [],
            };
            TmyChart.clear();
            Toption && TmyChart.setOption(Toption);
            if (myDate.length > 7) {
                let i = myDate.length - 7
                let aindex = 1
                this.timer = setInterval(() => {
                    if (this.autoTimePaused) return
                    TmyChart.dispatchAction({
                        type: 'dataZoom',
                        start: aindex * onepercent,
                        end: (aindex * onepercent + percent)
                    });
                    if (aindex == i) {
                        aindex = 0
                    } else {
                        aindex += 1
                    }
                }, 3000)
            } else {
                let timers = this.getRandomInt(25, 35)
                this.timer = setInterval(() => {
                    if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                    TmyChart.clear();
                    Toption && TmyChart.setOption(Toption);
                }, timers * 1000);
            }
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData();
        this.$nextTick(() => {
            // this.drawLine(); //需要刷新的数据
            this.TdrawLine(); //需要刷新的数据
        });
    },
};
</script>

<style scoped>
.rb {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    position: relative;
}

.Rmain {
    width: 435px;
    height: 240px;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    padding: 0px;
    margin: 0px;
    border-width: 0px;
}
</style>